import _ from 'lodash'

export function getSearchRegexString(searchTerm: string) {
	const parts = searchTerm
		.split(/[*?]/)
		.filter((part) => part)
		.map(x => `(${_.escapeRegExp(x)})`)
	const regex = parts.join('|')
	return regex // use new Regex(regex, 'gi').test('anything') to search with ignorecase
}